import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { MARKETING_CENTER_PATH } from '@constant'
import style from './index.module.less'
import Store from './store'
import { observer } from 'mobx-react'
import { goPayment } from '@util'
import { Modal, Button } from 'hljd'
import noticeStore from '@components/LocalMerchant/NoticeChat/store'

@observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    this.state = {
      imgList: [
        'https://qnm.hunliji.com/o_1di53rcag1k711ijf4r6rt313cuk.jpg?imageView2/2/w/750/h/720',
        'https://qnm.hunliji.com/o_1di53rcah11bp1bt8b4f1heloell.jpg?imageView2/2/w/750/h/463',
        'https://qnm.hunliji.com/o_1di53rcah1jms10se1vs12lau5om.jpg?imageView2/2/w/750/h/1035',
        'https://qnm.hunliji.com/o_1di53rcah165qdmd1jqi19hg1567n.jpg?imageView2/2/w/750/h/822',
        'https://qnm.hunliji.com/o_1dico2au31r161tl9v951cqt1fa59.jpg?imageView2/2/w/750/h/1224',
        'https://qnm.hunliji.com/o_1di53rcah1gk915k5dv1ag11ijp.jpg?imageView2/2/w/750/h/607',
        'https://qnm.hunliji.com/o_1di53rcahflgs6s1hr21u561bi5q.jpg?imageView2/2/w/750/h/770',
        'https://qnm.hunliji.com/o_1di53rcahdfl1fr51cltb3bvpdr.jpg?imageView2/2/w/750/h/884',
        'https://qnm.hunliji.com/o_1di53rcahblodgkki01bfaqvhs.jpg?imageView2/2/w/750/h/586',
        'https://qnm.hunliji.com/o_1di53rcaht096u7dmq1l7e1mbit.jpg?imageView2/2/w/750/h/974',
        'https://qnm.hunliji.com/o_1di53rcahtopl4r1j261t301o9pu.jpg?imageView2/2/w/750/h/622',
        'https://qnm.hunliji.com/o_1di6uknt7g7d2s1n6kuhb1nh7e.jpg?imageView2/2/w/750/h/352'
      ],
      visible: false,
      protocol: {
        title: '',
        content: ''
      }
    }
    this.store.getMerchantInfo()
    this.store.getPurchaseData()
  }

  componentDidMount() {
    noticeStore.setBottom('120px')
  }

  handleOpen = () => {
    const { isGeren, isOpened, purchaseData } = this.store
    const { flagship = {} } = purchaseData
    if (!isOpened) {
      // this.setState({
      //   visible: true,
      //   protocol: flagship.protocol
      // })
      // return false
      if (isGeren) {
        this.setState({
          visible: true,
          protocol: flagship.protocol
        })
      } else {
        Modal.info({
          title: '提示',
          content: '司仪个人商家服务（付费），仅限司仪商家开通'
        })
      }
    }
  }

  gotoPayment = () => {
    const { payMoney } = this.store
    const title = '购买司仪个人商家服务（付费）'
    let product_id = '262'

    this.setState({
      visible: false
    })
    goPayment({ title, fee: payMoney, product_id })
  }

  render() {
    const { isOpened, payMoney } = this.store
    const { protocol, visible } = this.state

    return (
      <HeaderView
        header={[
          <Link to={MARKETING_CENTER_PATH}>服务市场</Link>,
          '司仪个人商家服务'
        ]}
        title=""
        contentStyle={{
          padding: 0
        }}
      >
        <div className={style['scroll']} ref={scroll => (this.scroll = scroll)}>
          <div className="image-container">
            {this.state.imgList.map((item, key) => {
              return (
                <img className="flagship-img" key={key} src={item} alt="" />
              )
            })}
          </div>
          {/* 支付按钮 */}
          <div className="footer">
            <div className="left">
              服务优惠价：
              <div className="left-price">
                <span>￥</span>
                {payMoney}
              </div>
              /年
            </div>
            <div className="right">
              <div className="right-submit" onClick={this.handleOpen}>
                {isOpened ? '已开通' : '立即开通'}
              </div>
            </div>
          </div>
          {/* 协议 */}
          <Modal
            title={protocol.protocol_title}
            visible={visible}
            onOk={this.gotoPayment}
            onCancel={() => this.setState({ visible: false })}
            okText="开通商家服务"
            keyboard={false}
            width={700}
            wrapClassName={style.versionBox}
            footer={[
              <Button type="primary" key="ok" onClick={this.gotoPayment}>
                我同意遵守协议并继续下单
              </Button>
            ]}
          >
            <div
              style={{
                maxHeight: '500px',
                overflow: 'hidden',
                overflowY: 'auto'
              }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: protocol.protocol_content }}
              />
            </div>
          </Modal>
        </div>
      </HeaderView>
    )
  }
}

export default Index
